module.exports = __webpack_public_path__ + "4ab937c928516423eb1bd51028c3187c.pdf";